import { FC, useEffect, useState } from "react"
import { Footer } from "../../components/Footer/footer"
import { ChrevonLeftIcon } from "../../components/MenuIcons/ChevrotLeft"
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import myOrderImg from '../../assets/images/myOrder.svg'
import './index.css'
import { OrderItem } from "../../components/OrderItem/OrderItem";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { cpfMask, datetimeToDateBR } from "../../functions/mask";
import { centsToFloat } from "../../functions/price_functions";
import { AdditionalType, ItemFractionalType } from "../../contexts/OrderContext";
import useAuth from "../../hooks/useAuth";
import { CustomerOrder } from "./customerOrders/orders";
import { OrderDetails } from './orderDetails/orderDetails'



type ProductOrderType = {
    id: number;
    name: string;
    quantity: number;
    unitPrice: number;
    promotionalPrice: number;
    variation: string;
    fractions: ItemFractionalType[];
    additionals: AdditionalType[];
};

export type OrderFindedType = {
    id: number;
    ext: string;
    date: string;
    observation: string;
    type: string;
    status: Array<StatusResponseType>;
    allStatus: Array<StatusResponseType>;
    store: string;
    address: string;
    user: any;
    products: ProductOrderType[];
    totalValue: number;
    freight: number;
    statusId: number;
    content: any;
};

type StatusResponseType = {
    id: number;
    name: string;
    slug: string;
    order: number;
    displayStatusWebapp: boolean;
    colorSetting?: {
        background?: string
    };
};

type ProductResponseType = {
    id: number;
    code: string;
    content: any;
    sku: string;
    price: number;
    quantity: number;
    discount: number;
};

type PluginspaceResponseType = {
    name: string;
};

export type OrderResponseType = {
    id: number;
    classifierId: number | null;
    content: any;
    statusId: number;
    created: string;
    customerId: string;
    deliveryTax: number;
    discountGeral: number;
    locationId: number;
    orderidExt: string;
    pluginconfigId: number;
    pluginspaceId: number;
    products: Array<ProductResponseType>;
    status: Array<StatusResponseType>;
    type: string;
    pluginspace: PluginspaceResponseType;
    observation: string;
};

const CustomerLayout: FC = () => {
    const navigate = useNavigate();

    return (
        <div className="mainPage">

            <div className="mainContent">
                <div className="backae">
                    <ChrevonLeftIcon action={() => navigate(-1)} />
                </div>


                <Outlet />

                <Footer />
            </div>

        </div>
    )
}

const CustomerPage = () => {

    return (
        <Routes>
            <Route element={<CustomerLayout />}>
                <Route path='' element={<CustomerOrder />} />
                <Route path='/:ext' element={ <OrderDetails />} />
            </Route>
        </Routes>
    )
}


export { CustomerPage }